import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { NavigationModule } from 'src/core-lib/navigation/navigation.module';
import { PipeModule } from 'src/core-lib/pipes/pipe.module';
import { VarModule } from 'src/core-lib/var/var.module';
import { TagManagerModule } from 'src/externals/tag-manager/tag-manager.module';
import { GridModule } from 'src/layout/grid/grid.module';
import { MediaModule } from 'src/layout/media/media.module';
import { HeaderBasketButtonComponent } from './header/components/header-basket-button/header-basket-button.component';
import { HeaderMenuComponent } from './header/components/header-menu/header-menu.component';
import { HeaderSearchComponent } from './header/components/header-search/header-search.component';
import { RecursiveLinkComponent } from './header/components/recursive-link/recursive-link.component';
import { OverlayBasketComponent } from './overlay-basket/overlay-basket.component';
import { OverlayDropdownComponent } from './overlay-dropdown/overlay-dropdown.component';
import { OverlayLanguagesComponent } from './overlay-languages/overlay-languages.component';
import { OverlayMenuComponent } from './overlay-menu/overlay-menu.component';
import { OverlaySearchComponent } from './overlay-search/overlay-search.component';
import { SearchBarComponent } from './search-bar/search-bar.component';










@NgModule({
    declarations: [

        // FooterBedrockComponent,
        // FooterCardsComponent,
        // FooterContactComponent,
        // FooterCountrySelectorComponent,
        // FooterHoursOfOperationsComponent,
        // FooterLicensesComponent,
        // FooterMediasComponent,
        // FooterMenuComponent,
        // FooterSocialLinksComponent,
        // GetTemplatePipe,
        // GoogleMapLinkPipe,
        // HasNestedMenuPipe,
        // MenuToCtaPipe,
        // UnNestedMenuPipe,
        OverlayBasketComponent,
        OverlayDropdownComponent,
        OverlayLanguagesComponent,
        OverlayMenuComponent,
        OverlaySearchComponent,
        SearchBarComponent,

    ],
    imports: [
        TagManagerModule,
        CommonModule,
        MediaModule,
        NavigationModule,
        TranslateModule,
        ReactiveFormsModule,
        PipeModule,
        GridModule,
        VarModule,
        HeaderSearchComponent,
        HeaderBasketButtonComponent,
        HeaderMenuComponent,
        RecursiveLinkComponent,
    ],
    exports: []
})
export class ChromeModule {}
